Ext.layout.RowLayout = Ext.extend(Ext.layout.ContainerLayout, {

    monitorResize:true,

    extraCls: 'x-row',

    scrollOffset : 0,

    isValidParent : function(c, target){
        return c.getEl().dom.parentNode == this.innerCt.dom;
    },

    onLayout : function(ct, target){
        var cs = ct.items.items, len = cs.length, c, i, width;

        if(!this.innerCt){
            target.addClass('x-row-layout-ct');
            this.innerCt = target.createChild({cls:'x-row-inner'});
            this.innerCt.createChild({cls:'x-clear'});
        }
        this.renderAll(ct, this.innerCt);

        var size = Ext.isIE && target.dom != Ext.getBody().dom ? target.getStyleSize() : target.getViewSize();

        if(size.width < 1 && size.height < 1){
            return;
        }

        var h = size.height - target.getPadding('tb'),
            ph = h;

        this.innerCt.setHeight(h);

        for(i = 0; i < len; i++){
            c = cs[i];
            if(!c.rowHeight){
                ph -= (c.getSize().height + c.getEl().getMargins('tb'));
            }
        }

        ph = ph < 0 ? 0 : ph;

        for(i = 0; i < len; i++){
            c = cs[i];
            if(c.rowHeight){
                c.setHeight(Math.floor(c.rowHeight*ph) - c.getEl().getMargins('tb'));
            }
            if (c.doLayout){
                c.doLayout();
            };
        }
    }
});

Ext.Container.LAYOUTS['row'] = Ext.layout.RowLayout;